import {
    playTimeSearchType,
    projectBenefitTypes,
    projectCatalogCategories,
    projectPhaseSearchType,
    projectSearchPlayerAge,
    projectSearchPlayerCount,
    projectSearchSortType,
} from '@/Models';
import { enumNameToValue, enumValueToName } from '@/Utils/EnumUtility';

const defaultSortType = projectSearchSortType.default;

function enumParamNameToValue(enumDefinition, value) {
    if (typeof value !== 'string') {
        return value;
    }

    return enumNameToValue(enumDefinition, value);
}

function normalizeEnumArray(enumDefinition, values) {
    return (values || []).map((value) => enumParamNameToValue(enumDefinition, value));
}

function serializeEnumArray(enumDefinition, values) {
    const result = (values || [])
        .map((value) =>
            typeof value === 'string' ? value : enumValueToName(enumDefinition, value),
        )
        .filter((value) => value !== undefined);

    return result.length ? result : undefined;
}

function compact(params) {
    return Object.fromEntries(Object.entries(params).filter(([, value]) => value !== undefined));
}

export function createDefaultHomepageSectionSearchParams() {
    return {
        sortType: defaultSortType,
        projectPhaseSearchTypes: [],
        projectTags: [],
        playerCounts: [],
        playerAges: [],
        playTimes: [],
        projectBenefits: [],
        projectCatalogCategories: [],
        term: null,
    };
}

export function normalizeHomepageSectionSearchParamsForEditor(searchParams = {}) {
    return {
        ...createDefaultHomepageSectionSearchParams(),
        sortType: enumParamNameToValue(
            projectSearchSortType,
            searchParams.sortType ?? defaultSortType,
        ),
        projectPhaseSearchTypes: normalizeEnumArray(
            projectPhaseSearchType,
            searchParams.projectPhaseSearchTypes,
        ),
        projectTags: searchParams.projectTags || [],
        playerCounts: normalizeEnumArray(
            projectSearchPlayerCount,
            searchParams.playerCounts,
        ),
        playerAges: normalizeEnumArray(
            projectSearchPlayerAge,
            searchParams.playerAges,
        ),
        playTimes: normalizeEnumArray(
            playTimeSearchType,
            searchParams.playTimes,
        ),
        projectBenefits: normalizeEnumArray(
            projectBenefitTypes,
            searchParams.projectBenefits,
        ),
        projectCatalogCategories: normalizeEnumArray(
            projectCatalogCategories,
            searchParams.projectCatalogCategories,
        ),
        term: searchParams.term || null,
    };
}

export function serializeHomepageSectionSearchParams(searchParams = {}) {
    const sortType = enumParamNameToValue(projectSearchSortType, searchParams.sortType ?? defaultSortType);
    const params = {
        sortType: sortType === defaultSortType ? undefined : enumValueToName(projectSearchSortType, sortType),
        projectPhaseSearchTypes: serializeEnumArray(
            projectPhaseSearchType,
            searchParams.projectPhaseSearchTypes,
        ),
        projectTags: searchParams.projectTags?.length ? searchParams.projectTags : undefined,
        playerCounts: serializeEnumArray(
            projectSearchPlayerCount,
            searchParams.playerCounts,
        ),
        playerAges: serializeEnumArray(
            projectSearchPlayerAge,
            searchParams.playerAges,
        ),
        playTimes: serializeEnumArray(
            playTimeSearchType,
            searchParams.playTimes,
        ),
        projectBenefits: serializeEnumArray(
            projectBenefitTypes,
            searchParams.projectBenefits,
        ),
        projectCatalogCategories: serializeEnumArray(
            projectCatalogCategories,
            searchParams.projectCatalogCategories,
        ),
        term: searchParams.term || undefined,
    };

    return compact(params);
}
